import env from "Consts/env";

import * as tiktokPixel from "Helpers/tiktok-pixel";
import * as gtag from "Helpers/gtag";
import * as metaPixel from "Helpers/fb-pixel";
import Cookies from "js-cookie";

import { apiSlice } from "../api/apiSlice";

export const orderDetailApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({

		getOrderDetail: builder.query({
			query: (args) => ({
				url: `/api/fds-order/${args?.id}`,
				method: "get",
				headers: {
					...env.HEADERS,
				},
			}),
			onQueryStarted: async (arg, { queryFulfilled }) => {

				const response = await queryFulfilled;

				if (response?.data?.meta?.code === 200) {

					const trackedUnpaidOrderIds = Cookies.get("trackedUnpaidOrderIds");
					const trackPurchaseEvent = () => {

						const { data: orderDetail } = response?.data || {};

						if (orderDetail) {

							tiktokPixel.track(arg.pixel, {
								content_id: orderDetail.order_id,
								content_type: "product",
								currency: "IDR",
								value: orderDetail.total_price_exclude_shipping,
								total_qty_ordered: orderDetail.total_qty_ordered,
								total_item_count: orderDetail.total_item_count,
								shipping_price: orderDetail.shipping_price,
								contents: orderDetail.products.map((item) => ({
									id: item.product_id,
									sku: item.sku,
									quantity: item.qty,
									name: item.name,
									brand: item.brand?.name,
								})),
							});

							metaPixel.standardEvent(arg.pixel, {
								content_id: orderDetail.order_id,
								content_type: "product",
								currency: "IDR",
								value: orderDetail.total_price_exclude_shipping,
								total_qty_ordered: orderDetail.total_qty_ordered,
								total_item_count: orderDetail.total_item_count,
								shipping_price: orderDetail.shipping_price,
								contents: orderDetail.products.map((item) => ({
									id: item.product_id,
									sku: item.sku,
									quantity: item.qty,
									name: item.name,
									brand: item.brand?.name,
								})),
							});

							gtag.event({
								eventName: arg.gtag,
								parameter: {
									id: orderDetail.order_id,
									currency: "IDR",
									value: orderDetail.total_price_exclude_shipping,
									total_qty_ordered: orderDetail.total_qty_ordered,
									total_item_count: orderDetail.total_item_count,
									shipping_price: orderDetail.shipping_price,
									contents: orderDetail.products.map((item) => ({
										id: item.product_id,
										sku: item.sku,
										quantity: item.qty,
										name: item.name,
										brand: item.brand?.name,
									})),
									event_category: arg.gtag,
									event_label: arg.gtag,
								},
							});

						}

					};

					if (trackedUnpaidOrderIds) {

						const parsedTrackedUnpaidOrderIds = JSON.parse(trackedUnpaidOrderIds);

						// if orderId is not in trackedUnpaidOrderIds, run tracker
						// then add orderId to trackedUnpaidOrderIds Cookie
						// otherwise skip
						if (!parsedTrackedUnpaidOrderIds.includes(Number(arg.id))) {

							trackPurchaseEvent();

							parsedTrackedUnpaidOrderIds.push(Number(arg.id));

							Cookies.set(
								"trackedUnpaidOrderIds",
								JSON.stringify(parsedTrackedUnpaidOrderIds),
							);

						}

					} else {

						// user first time buying, trackedUnpaidOrderIds Cookie is still empty
						trackPurchaseEvent();

						Cookies.set("trackedUnpaidOrderIds", JSON.stringify([Number(arg.id)]));

					}

				}
				return response;

			},

		}),
	}),
});

export const {
	useGetOrderDetailQuery,
} = orderDetailApiSlice;
